import React, { useState, useEffect } from "react";
import { apiRequest } from "../api";

const AddEventTemplateModal = ({ eventTemplate, onClose, onSave }) => {
    const isEdit = !!eventTemplate;
    const [name, setName] = useState(eventTemplate?.name || "");
    const [eventDate, setEventDate] = useState(eventTemplate?.event_date || "");
    const [city, setCity] = useState(eventTemplate?.city || "");
    const [tourTemplateId, setTourTemplateId] = useState(eventTemplate?.tour_template_id || "");
    const [formTemplateId, setFormTemplateId] = useState(eventTemplate?.form_template_id || "");
    const [tourTemplates, setTourTemplates] = useState([]);
    const [formTemplates, setFormTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL || "https://localhost:8000";
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchTourTemplates();
        fetchFormTemplates();
    }, []);

    const fetchTourTemplates = async () => {
        try {
            const data = await apiRequest(`${apiUrl}/tour-templates`, "GET", null, token);
            setTourTemplates(data);
        } catch (err) {
            setTourTemplates([]);
        }
    };

    const fetchFormTemplates = async () => {
        try {
            const data = await apiRequest(`${apiUrl}/form-templates`, "GET", null, token);
            setFormTemplates(data);
        } catch (err) {
            setFormTemplates([]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            if (isEdit) {
                await apiRequest(
                    `${apiUrl}/event-templates/${eventTemplate.id}`,
                    "PUT",
                    { name, event_date: eventDate, city, tour_template_id: tourTemplateId, form_template_id: formTemplateId },
                    token
                );
            } else {
                await apiRequest(
                    `${apiUrl}/event-templates/`,
                    "POST",
                    { name, event_date: eventDate, city, tour_template_id: tourTemplateId, form_template_id: formTemplateId },
                    token
                );
            }
            onSave();
        } catch (err) {
            setError("Failed to save event template.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "500px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                }}
            >
                <h4>{isEdit ? "Edit Event Template" : "Add Event Template"}</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Event Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={eventDate}
                            onChange={(e) => setEventDate(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>City</label>
                        <input
                            type="text"
                            className="form-control"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Tour Template</label>
                        <select
                            className="form-control"
                            value={tourTemplateId}
                            onChange={(e) => setTourTemplateId(e.target.value)}
                            required
                        >
                            <option value="">Select Tour Template</option>
                            {tourTemplates.map((tt) => (
                                <option key={tt.id} value={tt.id}>{tt.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Form Template</label>
                        <select
                            className="form-control"
                            value={formTemplateId}
                            onChange={(e) => setFormTemplateId(e.target.value)}
                            required
                        >
                            <option value="">Select Form Template</option>
                            {formTemplates.map((ft) => (
                                <option key={ft.id} value={ft.id}>{ft.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? "Saving..." : "Save"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
                {error && (
                    <p
                        style={{
                            marginTop: "10px",
                            color: "red",
                        }}
                    >
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
};

export default AddEventTemplateModal; 